package app.footyguide.domain.model

import kotlinx.serialization.Serializable

/**
 * Jogador na escalação com posição no campo.
 *
 * @param position Posição abreviada: G = goleiro, D = defensor, M = meia, F = atacante
 * @param gridRow  Linha no campo (1 = goleiro, N = linha mais avançada)
 * @param gridCol  Coluna dentro da linha (1 = mais à esquerda)
 */
@Serializable
data class LineupPlayer(
    val name: String,
    val number: Int,
    val position: String,
    val gridRow: Int,
    val gridCol: Int,
)
